// extracted by mini-css-extract-plugin
module.exports = {"item":"BreadcrumbItem_item__4zgao","visuallyHidden":"BreadcrumbItem_visuallyHidden__tPOjV","separator":"BreadcrumbItem_separator__KK1AY"};